import { useCallback } from 'react';
import React from 'react';
import FHGTextField from '../../components/TextField';
import ModalDialog from '../../fhg/components/dialog/ModalDialog';
import useEditData from '../../fhg/components/edit/useEditData';

/**
 * Component to edit a single equalization time row.
 *
 * @param equalizationTimeValue The equalization time row to edit.
 * @param onSubmit Submit the changes to the equalization time row.
 * @param onClose Close the edit dialog.
 * @return {JSX.Element}
 * @constructor
 */
export default function EqualizationTimeEdit({ equalizationTimeValue, onSubmit, onClose }) {

   const [editValues, handleChange, { isChanged, getValue, defaultValues }] = useEditData(equalizationTimeValue);

   /**
    * Handle numeric input, digits only.
    */
   const handleMinutesChange = useCallback((event) => {
      const value = event.target.value;
      if (value === '' || /^\d*$/.test(value)) {
         handleChange(event);
      }
   }, [handleChange]);

   /**
    * Submit the changes to the equalization time row.
    */
   const handleSubmit = useCallback((event) => {

      if (event) {
         event.preventDefault();
         event.stopPropagation();
      }

      if (isChanged) {
         onSubmit && onSubmit({ ...defaultValues, ...editValues });
      }
   }, [editValues, defaultValues, isChanged, onSubmit]);

   return (
      <ModalDialog open={true} titleKey={'operator.equalizationTimeEdit.title'} onSubmit={(event) => handleSubmit(event)} maxWidth={'sm'}
         fullWidth onClose={onClose}>
         <FHGTextField
            name='label'
            type='text'
            autoFocus
            label={'Label'}
            style={{ marginBottom: 8 }}
            onChange={handleChange}
            value={getValue('label') || ''}
            required
         />
         <FHGTextField
            name='minutes'
            type='number'
            label={'Minutes'}
            step='1'
            inputProps={{
               min: '0',
               step: '1'
            }}
            style={{ marginBottom: 8 }}
            onChange={handleMinutesChange}
            value={getValue('minutes') || ''}
            required
         />
      </ModalDialog>
   );
}
